import React, { useState} from "react";
import BaseInput from "./BaseInput";
import {FiEye, FiEyeOff}  from "react-icons/fi";

const PasswordInput = (props) => {
    const [showPassword, setShowPassword] = useState(false);
    const {viewPassword = false, ...restProps} = props;
    const toggleShowPassword = () => {
        setShowPassword(!showPassword);
    };

    return viewPassword ? (
      <div className={`relative ${props.className}`}>
        <BaseInput type={showPassword ? 'text' : 'password'} {...restProps} />
        <button type="button" className="absolute inset-y-0 right-0 flex items-center px-3 focus:outline-none" onClick={toggleShowPassword}>
          {showPassword ? <FiEyeOff/> : <FiEye/>}
        </button>
      </div>
    ): (
      <BaseInput type="password" {...restProps} />
    )
};

export default PasswordInput;